module.exports = __webpack_public_path__ + "static/media/04.99492839.jpg";